import { useTheme } from '@mui/material';
import React, { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {}

const GraphLineIcon: React.FC<Props> = ({ width = 24, height = 13, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 4 7 8l5.5-4.5 5 4.5 5-3"
        stroke={theme.palette.text.secondary}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8 7 1l5.5 10.5L17 4l5.5-2.5"
        stroke={theme.palette.text.primary}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GraphLineIcon;
